import { createAction } from 'redux-actions';
import * as ActionTypes from './ActionTypes';

export const getEvent = createAction(ActionTypes.GET_EVENT.REQUEST);
export const writeEvent = createAction(ActionTypes.WRITE_EVENT.REQUEST);
export const getFeedback = createAction(ActionTypes.GET_FEEDBACK.REQUEST);
export const writeFeedback = createAction(ActionTypes.WRITE_FEEDBACK.REQUEST);
export const clearFeedbackAlert = createAction(ActionTypes.CLEAR_FEEDBACK_ALERT);

const initialState = {
	event : null,
	feedback : null,
    alertMessage : '',
}
// : '소중한 의견이 접수되었습니다.'
function feedback(state = initialState, action) {
    //console.info('[reducers.message.message][action]', action)
    switch(action.type) {
		case ActionTypes.GET_EVENT.REQUEST:
            return {...state}
		case ActionTypes.GET_EVENT.SUCCESS:
			return {
				...state,
                event : action.payload.response.data,
            }
		case ActionTypes.WRITE_EVENT.REQUEST:
			 return {...state}
		case ActionTypes.WRITE_EVENT.SUCCESS:
			let detailEvent = '이벤트 참여에 오류가 발생했습니다. <br/> 잠시 후 다시 시도 바랍니다.'
			if (action.payload.response.data.code === 0) {
				detailEvent = '이벤트 참여가 완료되었습니다.'
			}
			return {
				...state,
				alertMessage : detailEvent
			}
		case ActionTypes.WRITE_EVENT.FAILURE: 
			return action.payload.error
		case ActionTypes.GET_FEEDBACK.REQUEST:
            return {...state}
		case ActionTypes.GET_FEEDBACK.SUCCESS:
			return {
				...state,
                feedback : action.payload.response.data,
            }
        case ActionTypes.WRITE_FEEDBACK.REQUEST:
            return {...state}
        case ActionTypes.WRITE_FEEDBACK.SUCCESS:
            let detailFeedback = '의견 접수에 오류가 발생했습니다. <br/> 잠시 후 다시 시도 바랍니다.'
            if (action.payload.response.data.code === 0) {
                detailFeedback = '소중한 의견이 접수되었습니다.'
            }
            return {
				...state,
                alertMessage : detailFeedback
            }
        case ActionTypes.WRITE_FEEDBACK.FAILURE: 
            return action.payload.error
        case ActionTypes.CLEAR_FEEDBACK_ALERT: // 얼럿 후에 초기화
            return {
				...state,
                alertMessage : ''
            }
        default:
            return state;
    }
}

export default feedback;